<template>
  <div class="main full-height">
    <div class="legal-content frosted">
      <button class="back-button-top" @click="$router.back()">
        <img src="@/assets/images/back.svg" alt="Zurück">
        <span>Zurück</span>
      </button>

      <h1>Datenschutzerklärung</h1>
      <p class="last-update">Stand: März 2026</p>

      <div class="privacy-text">
        <section>
          <h2>1. Verantwortlicher</h2>
          <p>
            Verantwortlicher für die Datenverarbeitung in dieser App (Clink) ist Sebastian Brock. Bei Fragen zum Datenschutz erreichen Sie uns unter <b>mail@sebastianbrock.de</b>.
          </p>
        </section>

        <section>
          <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
          <p>
            Wir erheben Daten in folgenden Kategorien:
          </p>
          <ul>
            <li><b>Basisdaten:</b> E-Mail-Adresse und Passwort (gehasht) bei der Registrierung.</li>
            <li><b>Profildaten:</b> Gewählter Nutzername pro Gruppe</li>
            <li><b>Aktivitäts-Daten:</b> Dokumentation des Alkoholkonsums (Getränkeart, Menge, Zeitstempel) zur statistischen Auswertung innerhalb Ihrer geschlossenen Gruppen. Diese Daten dienen der internen Unterhaltung und Information der Gruppenmitglieder.</li>
            <li><b>Tracking-Daten bei QR-Scans:</b> Beim Scannen von QR-Codes innerhalb der App erfassen wir aus Sicherheits- und Analysezwecken den User-Agent (Browsertyp) und einen anonymisierten IP-Hash.</li>
          </ul>
        </section>

        <section>
          <h2>3. Weitergabe an Dritte</h2>
          <p>
            Eine Weitergabe Ihrer persönlichen Daten an Dritte findet nur in begrenztem Umfang statt:
          </p>
          <ul>
            <li><b>Stripe:</b> Für Zahlungen (Upgrades von Gruppen) werden Ihre Zahlungsdaten direkt an den Zahlungsdienstleister Stripe Inc. übermittelt. Wir speichern keine Kreditkartendaten.</li>
            <li><b>Push-Benachrichtigungen:</b> Um Sie über Ereignisse in Ihren Gruppen zu informieren, werden anonymisierte Push-Abonnement-Details verarbeitet. Diese sind optional und können deaktiviert werden.</li>
          </ul>
        </section>

        <section>
          <h2>4. Zwecke der Datenverarbeitung</h2>
          <p>
            Die Verarbeitung erfolgt zum Zweck der Bereitstellung der App-Funktionen, insbesondere der Gruppenverwaltung und der Dokumentation von Gruppenereignissen (Drinks).
          </p>
        </section>

        <section>
          <h2>5. Ihre Rechte</h2>
          <p>
            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
          </p>
        </section>

        <section>
          <h2>6. Datensicherheit</h2>
          <p>
            Wir setzen technische Sicherheitsmaßnahmen nach modernem Standard ein, um Ihre Daten vor Verlust, Manipulation oder unbefugtem Zugriff zu schützen (z.B. SSL-Verschlüsselung, Passwort-Hashing).
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView'
}
</script>

<style scoped>
.main {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background);
}

.legal-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  text-align: left;
  line-height: 1.6;
}

.back-button-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}

.back-button-top img {
  width: 20px;
  filter: var(--icon-filter);
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 1.2rem;
  margin-top: 25px;
  margin-bottom: 10px;
  color: var(--primary-color);
}

.last-update {
  color: var(--tertiary-color);
  font-size: 0.9rem;
  margin-bottom: 30px;
}

section {
  margin-bottom: 20px;
}

p, li {
  margin-bottom: 15px;
  color: var(--primary-color);
  opacity: 0.9;
}

ul {
  padding-left: 20px;
}
</style>
